// src/pages/Blog.js
import React, { useEffect, useState } from 'react';
import { Container, Typography, Grid, Card, CardContent, Button, CardMedia, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { collection, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig'; // Import Firestore

// Styled Card Component
const ArticleCard = styled(Card)({
  marginBottom: '20px',
  cursor: 'pointer',
  transition: '0.3s',
  '&:hover': {
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
  },
});

// Styled Button Component
const ReadMoreButton = styled(Button)({
  marginTop: '10px',
  color: '#4D8F55',
  fontWeight: 'bold',
});

const Blog = () => {
  const [articles, setArticles] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchArticles = async () => {
      const articlesSnapshot = await getDocs(collection(db, 'articles'));
      const articlesList = articlesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setArticles(articlesList);
    };

    fetchArticles();
  }, []);

  return (
    <Container sx={{ marginTop: '20px' }}>
      <Typography variant="h4" gutterBottom>
        Centru Blog
      </Typography>
      <Typography variant="body1" paragraph>
        Cele mai recente noutăți în materie de IT, lege și protecția datelor.
      </Typography>
      <Grid container spacing={4}>
        {articles.map((article) => (
          <Grid item xs={12} md={6} lg={4} key={article.id}>
            <ArticleCard>
              {/* Display article image */}
              {article.image && (
                <CardMedia
                  component="img"
                  height="140"
                  image={article.image}
                  alt={article.title}
                  sx={{ objectFit: 'cover' }}
                />
              )}
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {article.title}
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '0.5em' }}>
                  {article.shortDescription}
                </Typography>
                <ReadMoreButton
                  variant="text"
                  onClick={() => navigate(`/blog/${article.id}`)} // Correct navigation with useNavigate
                >
                  Citește mai mult
                </ReadMoreButton>
              </CardContent>
            </ArticleCard>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Blog;
